import React from "react"

export interface PagerProps {
    currentPage: number;
    totalPages: number;
    onChangePage: (pageNumber: number) => void;
}
export class Pager extends React.Component<PagerProps>{
    static MaxPages = 5;
    render() {
        if (this.props.totalPages <= 1)
            return <span />;

        let cPage = this.props.currentPage + 1;
        let array = [cPage];
        let offset = 1;
        while (array.length < Pager.MaxPages && array.length < this.props.totalPages) {
            if (array[0] > 1) {
                array = [cPage - offset, ...array]
            }
            if (array[array.length - 1] < this.props.totalPages) {
                array.push(cPage + offset)
            }
            offset++;
        }

        let previousPageIndex = Math.max(0, this.props.currentPage - 1);
        let nextPageIndex = Math.min(this.props.totalPages - 1, this.props.currentPage + 1);
        const { currentPage, totalPages } = this.props;
        return (
            <ul className="pagination" style={{ margin: 0 }}>
                <li className={`page-item ${currentPage === 0 ? "disabled" : ""}`} title={`1/${this.props.totalPages}`}>
                    <a className="page-link" onClick={_ => this.props.onChangePage(0)} aria-label="Previous">
                        <i className="fa fa-step-backward" aria-hidden="true" />
                    </a>
                </li>
                <li className={`page-item ${currentPage === 0 ? "disabled" : ""}`} title={`${previousPageIndex + 1}/${this.props.totalPages}`}>
                    <a className="page-link" onClick={_ => this.props.onChangePage(previousPageIndex)} aria-label="Previous">
                        <i className="fa fa-caret-left" aria-hidden="true" />
                    </a>
                </li>
                {
                    array.map(x =>
                        <li key={x} className={`page-item ${currentPage === (x - 1) ? "active" : ""}`} title={`${x}/${this.props.totalPages}`}>
                            <a className="page-link" onClick={_ => this.props.onChangePage(x - 1)}>{x}</a>
                        </li>)
                }
                <li className={`page-item ${currentPage === totalPages - 1 ? "disabled" : ""}`}
                    title={`${nextPageIndex + 1}/${this.props.totalPages}`}>
                    <a className="page-link" onClick={_ => this.props.onChangePage(nextPageIndex)} aria-label="Next">
                        <i className="fa fa-caret-right" aria-hidden="true" />
                    </a>
                </li>
                <li className={`page-item ${currentPage === totalPages - 1 ? "disabled" : ""}`}
                    title={`${this.props.totalPages}/${this.props.totalPages}`}>
                    <a className="page-link" onClick={_ => this.props.onChangePage(this.props.totalPages - 1)} aria-label="Next">
                        <i className="fa fa-step-forward" aria-hidden="true" />
                    </a>
                </li>
            </ul>
        );
    }
}
